import { CommonModule, DatePipe } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { VgBufferingModule } from '@videogular/ngx-videogular/buffering';
import { VgControlsModule } from '@videogular/ngx-videogular/controls';
import { VgCoreModule } from '@videogular/ngx-videogular/core';
import { VgOverlayPlayModule } from '@videogular/ngx-videogular/overlay-play';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ApplicantDocumentEditComponent } from './component/applicant-document-edit.component';
import { ConfirmationDialogComponent } from './component/confirmation-dialog.component';
import { MessageDialogComponent } from './component/message-dialog.component';
import { DndDirective } from './directives/dnd.directive';
import { SortableHeaderDirective } from './directives/sortable-header.directive';
import { FooterComponent } from './footer/footer.component';
import { AlertComponent } from './formState/alert.component';
import { NavbarComponent } from './navbar/navbar.component';
import { PhoneMaskPipe } from './pipe/phone-mask.pipe';
//import { PhonePipe } from './pipe/phone.pipe';
import { SSNMaskPipe } from './pipe/ssn-mask.pipe';
import { RecaptchaComponent } from './recaptcha/recaptcha.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { AuthenticationEffects } from './state/effects/authentication.effects';
import { LookupEffects } from './state/effects/lookup.effects';
import { RecaptchaEffects } from './state/effects/recaptcha.effects';
import { reducers } from './state/reducers';
import { ToastComponent } from './toast/toast.component';
import { CompareEqualValidatorDirective } from './validators/compare-equal-validator.directive';

@NgModule({
  exports: [
    NavbarComponent,
    FooterComponent,
    RecaptchaComponent,
    ToastComponent,
    CompareEqualValidatorDirective,
    AlertComponent,
    SpinnerComponent,
    SSNMaskPipe,
    PhoneMaskPipe,
    NgbPaginationModule,
    DndDirective,
    SortableHeaderDirective,
    NgMultiSelectDropDownModule,
    VgCoreModule,
    VgControlsModule,
    VgOverlayPlayModule,
    VgBufferingModule,
    ReactiveFormsModule,
    ApplicantDocumentEditComponent,
  ],
  declarations: [
    NavbarComponent,
    FooterComponent,
    RecaptchaComponent,
    ToastComponent,
    CompareEqualValidatorDirective,
    AlertComponent,
    SpinnerComponent,
    SSNMaskPipe,
    PhoneMaskPipe,
    DndDirective,
    SortableHeaderDirective,
    ApplicantDocumentEditComponent,
    ConfirmationDialogComponent,
    MessageDialogComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    HttpClientModule,
    NgxSpinnerModule,
    NgbModule,
    NgbPaginationModule,
    NgMultiSelectDropDownModule.forRoot(),
    ReactiveFormsModule,
    VgCoreModule,
    VgControlsModule,
    VgOverlayPlayModule,
    VgBufferingModule,
    StoreModule.forFeature('shared', reducers),
    EffectsModule.forFeature([RecaptchaEffects, LookupEffects, AuthenticationEffects])
  ],
  providers: [DatePipe]
})
export class SharedModule { }
